<template>
  <el-col :span="24" id="pettycash" v-loading.body="changingPage && !navigating" element-loading-text="Fetching page...">
    <ListViewHeader
      title="PETTY CASH"
      ref="listViewHeader"
      :meta="meta"
      :selection="selection"
      :currentPage="currentPage"
      :changePage="changePage"
      :handleBatchUpdateSelection="handleBatchUpdateSelection"
      :batchUpdateOptions="batchUpdateOptions"
      :showFilters="showFilters"
      :toggleFilters="toggleFilters"
      :hasCreatePermission="hasCreatePermission"
      :createRouteName="'NewPc'">
    </ListViewHeader>
    <el-row type="flex" justify="start" align="middle" style="padding: 0 12px; margin: 12px 0;">
      <el-col :span="6">
        <el-row type="flex" justify="start" align="middle">
          <el-button-group>
            <el-button
              :type="activeTab === 'open' ? 'primary' : null"
              :class="activeTab === 'open' ? 'focussedBtn' : 'unfocussedBtn'"
              @click="() => changeTab('open')">
              View Open Transactions
            </el-button>
            <el-button
              :type="activeTab === 'all' ? 'primary' : null"
              :class="activeTab === 'all' ? 'focussedBtn' : 'unfocussedBtn'"
              @click="() => changeTab('all')">
              View All Transactions
            </el-button>
          </el-button-group>
        </el-row>
      </el-col>
      <el-col :span="18">
        <Filters
        ref="filters"
        :filters="filters"
        :filtersVisible="showFilters"
        :filterSize="12"
        :autoApply="false"
        clearAction="clearPcState"
        clearMetadataAction="resetPcMeta"
        searchAction="fetchPcsWithQuery"
        transactionType="Pc"
        :lineFieldSearch="{ field: 'other_name', transactionType: 'pc' }"
        @filterCleared="() => $refs.filters.applyFilters()"
        @doneFiltering="getAppliedFilters">
        <template v-for="(f, i) in filters" v-slot:[`${f.type}${i}`]="props" :key="i">
          <component :key="i" :is="f.type" :properties="f.props" :ref="`${f.type+'_pc_ref'}`" />
        </template>
      </Filters>
      </el-col>
    </el-row>
    <el-row type="flex" justify="end" align="middle" v-loading="changingTab" element-loading-text="Loading...">
      <el-col>
        <el-row type="flex">
          <TransactionsConfList
            v-if="pcs"
            :aggridColumns="aggridColumns"
            name="pc_transactions_conf_list"
            ref="transactions_conf_list"
            :rows="pcs"
            :activeTab="activeTab"
            :baseQuery="baseQuery"
            :currentPage="currentPage"
          />
        </el-row>
        <el-row v-if="!meta.count && !isFilterLoading" align="middle" justify="center" class="nodata-heading">
          No data available
        </el-row>
      </el-col>
    </el-row>
  </el-col>
</template>

<script>
  import store from '@/store/store'
  import { mapGetters } from 'vuex'
  import Filters from '@/components/RetainedFilters.vue'
  import KeywordFilter from '@/components/FilterComponents/KeywordFilter'
  // import SelectFilter from '@/components/FilterComponents/SelectFilter'
  // import AutocompleteFilter from '@/components/FilterComponents/AutocompleteFilter'
  import HeaderInfoText from '@/components/HeaderInfoText'
  import ListViewHeader from '@/components/DataEntryListViewHeader'
  import { listViewMixins } from '@/Mixins/TransactionListViews'
  import { filterRefsMixin } from '@/Mixins/FilterRefs'
  import TransactionsConfList from '@/components/SigmaClientNew/TransactionsConfList.vue'
  import { retainFiltersOnEntry } from '@/Mixins/SigmaClientNew/transactionGridFilters'

  export default {
    components: {
      Filters,
      KeywordFilter,
      // SelectFilter,
      // AutocompleteFilter,
      HeaderInfoText,
      ListViewHeader,
      TransactionsConfList
    },
    mixins: [ listViewMixins, filterRefsMixin ],
    data () {
      return {
        tableHeight: 1000,
        showFilters: true,
        statusValues: [],
        aggridColumns: ['rowSelect', 'ledgerColumn', 'numberColumn', 'vendorColumn', 'descriptionColumn', 'currencyColumn', 'envelopeAmountColumn', 'batchColumn', 'actionsColumn'],
        activeTab: 'open',
        changingTab: false,
        openStatusOptions: [{label: 'DRAFT', value: 'DRAFT'}, {label: 'OPEN', value: 'OPEN'}],
        allStatusOptions: [{label: 'DRAFT', value: 'DRAFT'}, {label: 'OPEN', value: 'OPEN'}, {label: 'AUDITED', value: 'AUDITED'}, {label: 'POSTED', value: 'POSTED'}, {label: 'VOIDED', value: 'VOIDED'}, {label: 'CLOSED', value: 'CLOSED'}]
      }
    },
    methods: {
      getAppliedFilters () {
        this.$store.dispatch('clearSetPcFilterInfo')
        let extendedFilters = {}
        if (this.$refs.filters.getFilters.search) extendedFilters = { search: this.$refs.filters.getFilters.search }
        sessionStorage.setItem('paginationQuery', JSON.stringify({page: this.currentPage, ...this.$refs.filters.getFilters}))
        sessionStorage.setItem(`gridFilterModel:${this.$route.name}`, JSON.stringify({ page: this.currentPage, extendedFilters: extendedFilters }))
        this.$store.dispatch('setPcFilterInfo', { page: this.currentPage, ...this.$refs.filters.getFilters })
        this.$refs['transactions_conf_list'].extendedFilters = extendedFilters
      },
      /**
       * Handles transaction selection
       * @param selection
       */
      handleSelectionChange (selection) {
        let notThisPage = this.selection.filter(v => v.page !== this.currentPage)
        this.$store.dispatch('updateTransactionSelection', [...notThisPage, ...selection])
      },
      /**
       * Handles tab changes. The tab decides the statuses the view asks for, so the list is
       * reloaded from scratch with the column filters cleared.
       * @param tab
       */
      async changeTab (tab) {
        this.changingTab = true
        this.activeTab = tab
        sessionStorage.removeItem(`gridFilterModel:${this.$route.name}`)
        try {
          this.$store.dispatch('setActiveTab', tab)
          // The tab brings its own criteria, so the column filters start over
          if (this.$refs['transactions_conf_list']) this.$refs['transactions_conf_list'].resetColumnFilters()
          await Promise.all([
            this.$store.dispatch('resetPcMeta'),
            this.$store.dispatch('clearPcState', true),
            this.$store.dispatch('clearFilters'),
            this.$store.dispatch('clearSetPcFilterInfo'),
            this.$store.dispatch('updateTransactionSelection', [])
          ])
          // Clear Search Filter
          this.$refs.keywordFilter_pc_ref.keyword = ''
          await this.loadRows(1)
        } catch (e) {
          console.log(e)
        } finally {
          this.changingTab = false
        }
      },
      async changePage (page) {
        try {
          this.changingPage = true
          const searchText = this.$refs.filters.getFilters.search ? this.$refs.filters.getFilters.search : ''
          await this.loadRows(page, { search: searchText })
          sessionStorage.setItem('paginationQuery', JSON.stringify({page: page, ...this.$refs.filters.getFilters}))
          sessionStorage.setItem(`gridFilterModel:${this.$route.name}`, JSON.stringify({ page: page, extendedFilters: { search: this.$refs.filters.getFilters.search } }))
          this.$refs['transactions_conf_list'].restoreSelection(this.selection)
        } catch (e) {
          console.log(e)
        } finally {
          this.changingPage = false
        }
      },
      async filterRetained () {
        const saved = JSON.parse(sessionStorage.getItem(`gridFilterModel:${this.$route.name}`))
        if (saved && saved.extendedFilters && saved.extendedFilters.search && this.$refs) {
          this.$nextTick(() => {
            this.$refs.keywordFilter_pc_ref.keyword = saved.extendedFilters.search
          })
        }
      }
    },
    computed: {
      ...mapGetters({
        pcs: 'getPcs',
        meta: 'getPcMetadata',
        currentPage: 'getCurrentPcPage',
        getBatchById: 'getBatchById',
        getVendorById: 'getVendorById',
        selection: 'getSelectedTransactions',
        getCurrencyByBatchId: 'getCurrencyByBatchId',
        getActiveTab: 'getActiveTab',
        getcurrentFilters: 'getFilters',
        getPcFilterInfo: 'getPcFilterInfo',
        checkIfUserHasRequiredPermissions: 'checkIfUserHasRequiredPermissions'
      }),
      /**
       * The statuses the selected tab asks for. Read from the tab rather than kept alongside it,
       * so they are right however the view was entered.
       * @return {Array}
       */
      selectedStatuses () {
        if (this.activeTab === 'all') return ['DRAFT', 'OPEN', 'AUDITED', 'POSTED', 'VOIDED', 'CLOSED']
        return ['DRAFT', 'OPEN']
      },
      /**
       * Criteria this view owns, which the grid's column filters are applied on top of
       */
      baseQuery () {
        return { status__in: this.selectedStatuses }
      },
      hasCreatePermission () {
        return this.checkIfUserHasRequiredPermissions(['entry.view_pettycash', 'entry.add_pettycash'])
      },
      hasPermission () {
        return {
          read: this.hasReadPermission
        }
      },
      hasReadPermission () {
        let readPermission = ['entry.view_pettycash']
        return this.checkIfUserHasRequiredPermissions(readPermission)
      },
      filters () {
        return [
          {
            type: 'keywordFilter',
            props: {}
          }
          // {
          //   type: 'selectFilter',
          //   props: {
          //     filterName: 'status',
          //     clearable: true,
          //     opts: this.activeTab === 'all' ? this.allStatusOptions : this.openStatusOptions,
          //     defaults: this.selectedStatuses || [],
          //     multi: true,
          //     placeholder: 'Status'
          //   }
          // },
          // {
          //   type: 'autocompleteFilter',
          //   props: {
          //     filterName: 'batch',
          //     remote: true,
          //     clearable: true,
          //     action: 'fetchBatchesWithQuery',
          //     clearAction: 'clearBatchState',
          //     getter: 'getBatchesBySearchCriteria',
          //     triggerOnFocus: false,
          //     placeholder: 'Batch',
          //     queryParamType: 'search',
          //     suggestionLabelAttr: 'name'
          //   }
          // },
          // {
          //   type: 'autocompleteFilter',
          //   props: {
          //     filterName: 'sourcecode',
          //     remote: true,
          //     clearable: true,
          //     action: 'fetchSourcecodesWithQuery',
          //     clearAction: 'clearSourcecodeState',
          //     getter: 'getSourcecodesBySearchCriteria',
          //     triggerOnFocus: false,
          //     placeholder: 'Source code',
          //     queryParamType: 'search',
          //     suggestionLabelAttr: 'name'
          //   }
          // },
          // {
          //   type: 'selectFilter',
          //   props: {
          //     filterName: 'batch__bank__currency',
          //     clearable: true,
          //     opts: this.currencyOptions,
          //     multi: true,
          //     placeholder: 'Currency',
          //     styles: '0 4px'
          //   }
          // }
        ]
      },
      currencyOptions () {
        return this.$store.getters.getAllCurrencies.map(c => ({ label: c.code, value: c.id }))
      }
    },
    created () {
      this.activeTab = this.getActiveTab
    },
    mounted () {
      const tableHeight = () => {
        const parentHeight = document.getElementById('pettycash').offsetHeight
        const headerHeight = document.getElementById('list-view-header').offsetHeight
        return parentHeight - headerHeight
      }
      this.tableHeight = tableHeight()
    },
    beforeUnmount () {
      this.$store.dispatch('updateTransactionSelection', [])
      this.$store.dispatch('updateFilteredTransactionSelection', [])
    },
    async beforeRouteEnter (to, from, next) {
      // Settled before the grid is built, so it only finds filters to put back on a return trip
      retainFiltersOnEntry(to.name, from.name)
      try {
        await Promise.all([
          store.dispatch('resetPcMeta'),
          store.dispatch('clearPcState', true),
          store.dispatch('fetchUiSetting', { name: 'DEFAULT_PC_CUSTODIAN' }),
          store.dispatch('fetchUiSetting', { name: 'CONFIRM_ON_POST' })
        ])
      } catch (e) {
        console.log(e)
      } finally {
        next(vm => {
          vm.filterRetained()
        })
      }
    },
    async beforeRouteLeave (to, from, next) {
      try {
        await store.dispatch('clearPoState', true)
      } catch (e) {
        console.log(e)
      } finally {
        next()
      }
    }
  }
</script>

<style scoped>
  .h-padded {
    padding: 0 12px;
  }
  .left-aligned-col {
    text-align: left;
  }
  .right-aligned-col {
    text-align: right;
  }
  .el-table .modified-row {
    background: #c9e5f5;
  }
  a, a:visited {
    text-decoration: none;
    color: rgb(0, 0, 238) !important;
  }
</style>